export default "__VITE_ASSET__cec5dff5__"